import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=3e508080&scoped=true&"
import script from "./PermissionsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsList.vue?vue&type=style&index=0&id=3e508080&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e508080",
  null
  
)

export default component.exports